import React, { createContext, useState } from "react";
import { JulianDate } from "cesium";
export const ClockContext = createContext({
    setClock: () => null,
    clockRange: {
        startTime: null,
        endTime: null,
    },
    getCurrentDate: () => null,
});
export const ClockProvider = ({ children }) => {
    const [clock, setClock] = useState();
    const getCurrentDate = () => (clock === null || clock === void 0 ? void 0 : clock.currentTime) && JulianDate.toDate(clock === null || clock === void 0 ? void 0 : clock.currentTime);
    const values = {
        setClock,
        clockRange: {
            startTime: (clock === null || clock === void 0 ? void 0 : clock.startTime) && JulianDate.toDate(clock === null || clock === void 0 ? void 0 : clock.startTime),
            endTime: (clock === null || clock === void 0 ? void 0 : clock.stopTime) && JulianDate.toDate(clock === null || clock === void 0 ? void 0 : clock.stopTime),
        },
        getCurrentDate,
    };
    return (React.createElement(ClockContext.Provider, { value: values }, children));
};
//# sourceMappingURL=ClockContext.js.map